// constants/queueConstants.js
export const districts = [
    "Голосіївський", 
    "Дарницький", 
    "Деснянський", 
    "Дніпровський", 
    "Оболонський", 
    "Печерський", 
    "Подільський", 
    "Святошинський", 
    "Солом'янський", 
    "Шевченківський"
];

export const ageRanges = [1, 2, 3, 4, 5, 6, 7];

export const ageRangeLabels = {
    1: "1-2",
    2: "2-3", 
    3: "3-4",
    4: "4-5",
    5: "5-6", 
    6: "6-7",
    7: "7-8"
};

export const tableHeaders = [
    { key: 'number', label: '№' },
    { key: 'district', label: 'Район' },
    { key: 'kindergarten', label: 'ЗДО' },
    ...ageRanges.map(age => ({ 
        key: `age_${age}`, 
        label: `${age}-${age + 1}`
    }))
];